<template>
  <div>
    <div class="policy">
      <!-- <div v-wechat-title="$route.meta.title = title"></div> -->
      <div v-html="realNamePolicy"></div>
    </div>
  </div>
</template>
<script>

// import BottomBar from '@/components/BottomBar'
import api from '@/api'
// import getUid from '@/utils/getUid'
// import { initRem } from '@/JS/initRem'

export default {
  components: {
    // BottomBar
  },
  data () {
    return {
      userPolicy:'',
      privacyPolicy:'',
      realNamePolicy:'实名认证协议'
    }
  },
  created: function () {
    // this.getId()
  },
  mounted: function () {
    this.getDetail()
    // this.getDet()
  },
  methods:{
    getDetail () {
      // console.log('用户协议')
      // 协议类型 1：用户协议 2：隐私政策 3：用户实名认证协议
      api.realNamePolicyApi({agreementType:3}).then(res => {
          if(res.code == 200){
            res = res.result
            this.realNamePolicy = res.agreementContent
          }else{
            this.$toast(res.message)
          }
        })
        .catch(e => {
          this.$toast(e)
          console.log('e', e)
        })
    },

  }
}
</script>
<style lang="less" scope>
@black:#333;
@gray:#666;
@blue: #4065E0;
.policy{
  background: #fff;
  margin-bottom: 83px;
  padding: 16px;
  img{
    width: 100%;
  }
  video {
    width: 100%;
  }
}
</style>

